var map = {
	"./ar.json": [
		"ziBS",
		14
	],
	"./ca.json": [
		"AjqM",
		13
	],
	"./de.json": [
		"zzZj",
		12
	],
	"./en.json": [
		"M0gs",
		11
	],
	"./es.json": [
		"8/YH",
		10
	],
	"./fr.json": [
		"3a6q",
		9
	],
	"./hi.json": [
		"wvuI",
		8
	],
	"./it.json": [
		"+pfc",
		7
	],
	"./ja.json": [
		"LHvj",
		6
	],
	"./ko.json": [
		"OZeQ",
		5
	],
	"./pt.json": [
		"Mos2",
		4
	],
	"./ru.json": [
		"Hi5Q",
		3
	],
	"./tr.json": [
		"I8NE",
		2
	],
	"./zh.json": [
		"fIQM",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "t7MB";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./static/langs lazy ^\.\/.*\.json$
// module id = t7MB
// module chunks = 17